import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../customer.service';
import { CheckoutDTO } from '../../../../shared/checkout-dto';
import { Location } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AccountService } from '../account.service';
import { AccountDTO } from '../../../../shared/account-dto';

@Component({
  selector: 'pv-cart-details',
  templateUrl: './cart-details.component.html',
  styleUrls: ['./cart-details.component.scss']
})
export class CartDetailsComponent implements OnInit {
  checkoutDTO: CheckoutDTO;
  taxRate: number = 0;
  shipping: number;
  itemTotal: number;
  giftCard: number = 0;
  total: number;
  grandTotal: number;
  errorMessage: string;
  freeShippingLabel: any;
  otherShippingLabel: any;
  otherShippingLabels: any;
  isInternational = false;
  shipDate: Date;
  isWholesale = false;
  moneyLeft;
  account: AccountDTO;

  constructor(
    private customerService: CustomerService,
    private location: Location,
    private title: Title,
    private router: Router,
    private accountService: AccountService
  ) {
    this.checkoutDTO = customerService.checkoutDTO
  }

  ngOnInit() {
    this.account = this.accountService.account;
    this.title.setTitle(`My Cart - ${this.accountService.account.name}`);
    this.checkoutDTO = this.customerService.checkoutDTO;
    this.isWholesale = this.checkoutDTO.customer.is_wholesale;
    this.updatePrice();

    // Update price whenever checkoutDTO changes
    this.customerService.checkoutSubject
    .subscribe(checkoutDTO => {
      this.checkoutDTO = checkoutDTO;
      this.isInternational = checkoutDTO.customer.ship_country_iso && checkoutDTO.customer.ship_country_iso != 'US';
      this.updatePrice();
      this.isWholesale = checkoutDTO.customer.is_wholesale;
    })

    // Get Free Shipping
    //TODO: UPDATE FOR SHIPPING RATES
    if (this.customerService.checkoutDTO.customer && !this.customerService.checkoutDTO.customer.is_wholesale) {
      this.customerService.getFreeShipping()
      .subscribe(({ free, other }) => {
        if (free) {
          this.freeShippingLabel = free;
          this.moneyLeft = this.freeShippingLabel.min_cart - this.itemTotal;
        }
        if (other) {
          this.otherShippingLabel = other;
        }
        // else if (others) {
        //   this.otherShippingLabels = others;
        // }
      })
    }
  }

  updatePrice() {
    if (this.checkoutDTO.cart.preorderDate)
    {
      this.checkoutDTO.cart.preorderDate = this.newUTCDateFromDBDate(this.checkoutDTO.cart.preorderDate);
      this.shipDate = this.newUTCDateFromDBDate(this.checkoutDTO.cart.preorderDate);
    }

    this.itemTotal = this.checkoutDTO.cart.totalPretax;
    this.total = this.itemTotal + (this.taxRate * this.itemTotal);
    this.grandTotal = this.total;
    const totalCredits = 0;
    this.giftCard = totalCredits > this.total ? this.total : totalCredits;
    if (this.freeShippingLabel) {
      this.moneyLeft = this.freeShippingLabel.min_cart - this.itemTotal
    }
  }

  emptyCart() {
    this.customerService.emptyCart();
  }

  async onRefresh() {
    (await this.customerService.fetchCart()).subscribe(data => console.log(data))
  }

  back() {
    this.location.back();
  }

  hasPreorder(): boolean {
    return !!this.checkoutDTO.cart.items.find(i => i.isPreorder && i.isPhysical)
  }

  stopEditing() {
    this.emptyCart();
    this.router.navigate(['/profile']);
  }

  newUTCDateFromDBDate(date) {
    var origDateObj = new Date(date);

    // set this object up with the origDateObj.getUTCDate() as the day
    var newDateObj = new Date(origDateObj.getUTCFullYear(), origDateObj.getUTCMonth(), origDateObj.getUTCDate());
    return newDateObj;
  }
}
